import { toUpperCase } from './helpers/string';
import {
	type ManageUserPrivacySettingsApiValue,
	type ManageUserPrivacySettingsSchemaValue,
	PRIVACY_SETTINGS_SCHEMA_TO_API_MAP,
} from './manage-user-privacy-settings';

const getAllowedPrivacySettingsFor = (
	data: Record<ManageUserPrivacySettingsApiValue, string[]>,
	schemaValue: ManageUserPrivacySettingsSchemaValue,
) => {
	const apiResponseKey = PRIVACY_SETTINGS_SCHEMA_TO_API_MAP[schemaValue];
	const allowedPrivacySettings = data[apiResponseKey];
	if (!allowedPrivacySettings || !allowedPrivacySettings.length) {
		return null;
	}
	return allowedPrivacySettings.map(toUpperCase);
};

export const transformUserManagePrivacySettingsAllowed = (
	data: Record<ManageUserPrivacySettingsApiValue, string[]>,
) =>
	Object.keys(PRIVACY_SETTINGS_SCHEMA_TO_API_MAP).reduce<Record<string, (string | null)[] | null>>(
		(memo, schemaValue) => {
			memo[schemaValue as ManageUserPrivacySettingsSchemaValue] = getAllowedPrivacySettingsFor(
				data,
				schemaValue as ManageUserPrivacySettingsSchemaValue,
			);
			return memo;
		},
		{},
	);
